<script lang="ts">
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import type { PwNextFocusCardProps } from './types';

  export let entryId: PwNextFocusCardProps['entryId'];
  export let customCssClass: PwNextFocusCardProps['customCssClass'];
  export let cardContent: PwNextFocusCardProps['cardContent'];
  export let href: PwNextFocusCardProps['href'];
  export let linkText: PwNextFocusCardProps['linkText'];
  export let image: PwNextFocusCardProps['image'];
</script>

<div class="PwNextFocusCard PwNextFocusCard-{entryId}-box-properties {customCssClass}" data-entry-id={entryId}>
  <div class="PwNextFocusCard__content">
    <!-- This link will be positioned over the full FocusCard, does not need content inside the anchor
        Avoids the nested anchor issue: https://github.com/sveltejs/kit/issues/10990
    -->
    <a {href} aria-label={linkText} tabindex="0" class="PwNextFocusCard__anchor"></a>
    <div class="PwNextFocusCard__img-wrapper">
      <DynamicChildrenComponent children={image} />
    </div>
    <div class="PwNextFocusCard__link">
      <DynamicChildrenComponent children={cardContent} />
    </div>
  </div>
</div>

<style lang="scss">
  @layer custom-components {
    .PwNextFocusCard {
      position: relative;

      &__anchor {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 8;
      }

      &__hover-text {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 8;
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.3s ease;

        :global {
          .Text {
            color: var(--color-white);
          }
        }
      }

      &__img-wrapper {
        position: relative;
      }

      :global {
        .AproposImageComponent {
          img {
            transition: transform var(--duration-default) var(--easing-standard);
          }
          picture {
            overflow: hidden;
            display: block;
            border-radius: 0.6rem;
          }
        }
      }

      &__link {
        padding-top: var(--space-20);
      }

      &__content {
        display: block;
        &:hover {
          :global(.AproposImageComponent img) {
            transform: scale(var(--zoom-in-scale));
          }
        }
      }
    }
  }
</style>
